import {
  Button,
  CardContent,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import UserContext from 'contexts/user';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getSULabToken, login, register } from '../../actions/auth';
import './index.css';

const LoginForm = () => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const { user, setUser } = useContext(UserContext);
  const [loggedInThroughForm, setLoggedInThroughForm] = useState(false);
  const [name, setName] = useState('');

  const [firstTimeLogin, setFirstTimeLogin] = useState(false);
  if (user && !loggedInThroughForm) {
    enqueueSnackbar('Already logged in', {
      variant: 'info',
      preventDuplicate: true,
    });
    history.push('/');
  }
  const search = window.location.search; // could be '?foo=bar'
  const params = new URLSearchParams(search);
  const token = params.get('sapien_token'); // bar
  /** look at token url parameter and store it and setUser */
  const handleLogin = () => {
    if (token !== null) {
      login(token)
        .then((user) => {
          // check if this is first time login
          if (!user) {
            setFirstTimeLogin(true);
          } else {
            setLoggedInThroughForm(true);
            setUser(user);

            enqueueSnackbar('Logged in successfully', {
              variant: 'success',
            });
            history.push('/');
          }
        })
        .catch((err: Error) => {
          enqueueSnackbar(err.message, {
            variant: 'error',
          });
        });
    }
  };
  useEffect(() => {
    handleLogin();
  }, []);
  const handleUsernameChange = (e: any) => {
    setName(e.target.value);
  };
  const handleRegister = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (name.includes(' ')) {
      // string has whitespace
      enqueueSnackbar('Username can not have white space', {
        variant: 'error',
      });
      return;
    }
    register(token as string, name)
      .then((user) => {
        enqueueSnackbar('Logged in first time successfully', {
          variant: 'success',
        });
        setLoggedInThroughForm(true);
        setUser(user);
        history.push('/');
      })
      .catch((e) => {
        enqueueSnackbar(`${e}`, {
          variant: 'error',
        });
      });
  };

  const SuLabUser = getSULabToken();

  return (
    <div className="LoginForm">
      <Paper elevation={3} className="login-card">
        {firstTimeLogin ? (
          <>
            <CardContent>
              <Typography variant="h4" style={{ fontWeight: 700 }}>
                Register
              </Typography>
              <br />
              <Typography variant="body1">
                You are logging in the first time with email {SuLabUser?.email}.
                Please provide a username
              </Typography>
              <form onSubmit={handleRegister}>
                <TextField
                  style={{ width: '100%' }}
                  label="Username"
                  type="text"
                  required
                  onChange={handleUsernameChange}
                />
                <br />
                <br />
                <Button
                  className="submit-btn"
                  variant="contained"
                  type="submit"
                >
                  Register
                </Button>
              </form>
            </CardContent>
          </>
        ) : (
          <CardContent>
            <Typography variant="h4" style={{ fontWeight: 700 }}>
              Login/Register
            </Typography>
            <br />
            <Typography variant="body2">
              If you are a first time user you will need to register an account
              with SAPIEN
            </Typography>
            <br />
            <a
              href={`https://sapien.ucsd.edu/login?redirect=${window.origin}${process.env.PUBLIC_URL}/login`}
            >
              <Button className="submit-btn" variant="contained">
                Sign In with SAPIEN
              </Button>
            </a>
          </CardContent>
        )}
      </Paper>
    </div>
  );
};

export default LoginForm;
